// Warehouse build costs, monthly maintenance, and capacity by port size.
// Tiny ports cannot have warehouses.

export const WAREHOUSE_COSTS = {
  small:  { buildCost:  200000, monthlyMaintenance:  10000, capacity:  200 },
  medium: { buildCost:  500000, monthlyMaintenance:  25000, capacity:  500 },
  large:  { buildCost: 1000000, monthlyMaintenance:  50000, capacity: 1000 },
  major:  { buildCost: 2000000, monthlyMaintenance: 100000, capacity: 2000 }
};

// Upgrade costs and capacity increases per level.
// Level 1 is the base (built via WAREHOUSE_COSTS above).
// Level 2 requires 'warehouse_expansion' research.
// Level 3 requires 'warehouse_expansion' research.
export const WAREHOUSE_UPGRADES = {
  small: {
    2: { cost:  300000, maintenanceIncrease:  5000, capacityBonus: 150 },
    3: { cost:  600000, maintenanceIncrease: 10000, capacityBonus: 150 }
  },
  medium: {
    2: { cost:  750000, maintenanceIncrease: 12500, capacityBonus: 350 },
    3: { cost: 1500000, maintenanceIncrease: 25000, capacityBonus: 400 }
  },
  large: {
    2: { cost: 1500000, maintenanceIncrease: 25000, capacityBonus: 750 },
    3: { cost: 3000000, maintenanceIncrease: 50000, capacityBonus: 1000 }
  },
  major: {
    2: { cost: 3000000, maintenanceIncrease: 50000, capacityBonus: 1500 },
    3: { cost: 6000000, maintenanceIncrease: 100000, capacityBonus: 2000 }
  }
};
